
<template>
  <div class="ui-sub-title-text" :style="style">
      <slot></slot>                
  </div>
</template>

<script>
export default {

    name: 'UITitle',

    props: {
      align: {
        type: String,
        default: 'left'
      }
    },

    computed: {
      style () {
        return {
          '--align': this.align
        }
      }
    },
}
</script>

<style>
  .ui-sub-title-text{
    font-family: 'Helvetica';
    font-weight: 600;
    font-size: 27px;
    line-height: 1.5em;
    color: #000000;
  }
  @media (max-width: 1650px) {
    .ui-sub-title-text{
      font-size: 24px;
    }
  }
  @media (max-width: 1350px) {
    .ui-sub-title-text{
      font-size: 20px;
    }
  }
  @media (max-width: 850px) {
    .ui-sub-title-text{
      font-size: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// UISubTitle.vue?5c716289